// extracted by mini-css-extract-plugin
export default {"imageContainer":"JB6Xp","image":"SVqe7","imageFit":"_3_Q3C","titleContainer":"_3RsKE","title":"owLPC"};